import { Navigation, Navigator } from '@/utils/tools/navigation'
import { navigate } from 'gatsby'

const routes = {
  // add a new route following the pattern of the others
  Home: 'feed/',
  Learn: {
    Learn: 'learn/',
    Content: 'learn/{{id}}',
    Search: 'learn/search',
    Lesson: 'learn/lessonView/{{id}}',
    Collection: 'learn/chapter/{{id}}',
    MyJourney: 'learn/my_journey',
  },
  Feed: {
    Feed: 'feed/',
    Item: 'feed/{{id}}',
    Search: 'feed/search',
  },
  TestPanel: 'test-panel/',
} as const

const navigator: Navigator = (path, options) => navigate(path as never, options as never)

export const navigation = new Navigation<{}, typeof routes>(routes, navigator)
